import React from 'react';
import { Container } from 'reactstrap';
import NavMenu  from '../shared/nav.menu';

const Layout = (props) => {
    return (
      <div>
        <NavMenu />
        <Container fluid={true}>{props.children}</Container>
      </div>
    );
};

export default Layout;
